module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qresp6-936cfc323ab5d02bf9575f2a5fa3176c.jpg";